import * as React from "react";

const SvgIcnAcceptLarge = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M9.852 15.21l7.372-7.975a.72.72 0 011.056 0 .84.84 0 010 1.14l-7.695 8.305a1 1 0 01-1.467 0L6.22 13.552a.84.84 0 01-.005-1.136.709.709 0 011.044-.005l2.593 2.798z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnAcceptLarge;
